import { IPageProps } from '@vfit/consumer/data-access';
import React from 'react';
import { withProtected } from '../Templates/Hoc/withProtected';
import ClickToCallTestConfigurations from '../ClickToCallTestConfigurations/clickToCallTestConfigurations';
import { LoggerInstance } from '@vfit/shared/data-access';

const ClickToCallTestPage = (props: IPageProps) => {
  LoggerInstance.log('ClickToCallTestPage', props);
  return <ClickToCallTestConfigurations />;
};

const ClickToCallTestPageProtected = withProtected()(ClickToCallTestPage);

export default ClickToCallTestPageProtected;
